module.exports = __webpack_public_path__ + "static/media/ES-Uvic.2f950a5f.png";